






























import PrefixesPopularAdd from "@/components/PrefixesPopularAdd.vue";
import KeyName from "@/components/KeyName.vue";
import { Prefix, Key } from "@/types/debug-mode";
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
    PrefixesPopularAdd,
    KeyName,
  },
})
export default class PrefixesPopular extends Vue {
  @State(state => state.debugMode.prefixes) watchedPrefixes!: Prefix[] | null;

  @Prop({ required: true })
  popularPrefixes!: undefined | null | Key[];

  @Prop({ required: false, default: "" })
  subPrefixBase!: string;

  @Prop({ required: false, default: "" })
  maxHeight!: string; // e.g. 224px

  get inlineStyles() {
    return this.maxHeight ? { maxHeight: this.maxHeight } : "";
  }

  get popularPrefixesFiltered(): Key[] {
    let popularPrefixes = this.popularPrefixes;
    if (!popularPrefixes) return [];

    const watchedPrefixes = this.watchedPrefixes;

    // Exclude prefixes where popularity = 1 because it
    // represents a prefix that includes 100% of requests
    popularPrefixes = popularPrefixes.filter(popularPrefix => popularPrefix.popularity !== 1);

    // If watching prefixes...
    if (watchedPrefixes && watchedPrefixes.length > 0) {
      // Exclude watched prefixes
      const watchedPrefixNames = watchedPrefixes.map(prefix => prefix.name);
      popularPrefixes = popularPrefixes.filter(popularPrefix => watchedPrefixNames.indexOf(popularPrefix.name) === -1);

      // Exclude sub prefixes of watched prefixes for overall popular prefixes
      if (!this.subPrefixBase) {
        popularPrefixes = popularPrefixes.filter(
          popularPrefix =>
            !watchedPrefixNames.some(watchedPrefixName => popularPrefix.name.startsWith(watchedPrefixName)),
        );
      }
    }

    // Exclude sub prefixes
    // sort prefixes by name ASC
    popularPrefixes.sort(function(a: any, b: any) {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    let parentPrefixName: string;
    popularPrefixes = popularPrefixes.filter((popularPrefix, i) => {
      const prefixName = popularPrefix.name;

      if (i === 0) {
        parentPrefixName = prefixName;
        return true;
      }

      if (prefixName.startsWith(parentPrefixName)) {
        return false;
      }

      parentPrefixName = prefixName;
      return true;
    });

    // For prefix-specific popular sub prefixes, exclude prefixes not starting with the sub prefix base.
    if (this.subPrefixBase) {
      popularPrefixes = popularPrefixes.filter(popularPrefix => popularPrefix.name.startsWith(this.subPrefixBase));
    }

    // Sort filtered prefixes by greatest popularity
    popularPrefixes.sort((a, b) => b.popularity - a.popularity);

    return popularPrefixes;
  }
}
